var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-square-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M15,13H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M12,16a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v6A1,1,0,0,1,12,16Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M12,2a22.363,22.363,0,0,1,4.75.388,6.371,6.371,0,0,1,3.236,1.626C21.658,5.685,22,8.415,22,12a22.363,22.363,0,0,1-.388,4.75,6.371,6.371,0,0,1-1.626,3.236C18.315,21.658,15.585,22,12,22a22.363,22.363,0,0,1-4.75-.388,6.371,6.371,0,0,1-3.236-1.626C2.342,18.315,2,15.585,2,12a22.363,22.363,0,0,1,.388-4.75A6.371,6.371,0,0,1,4.014,4.014C5.685,2.342,8.415,2,12,2Zm0,18c3.654,0,5.558-.414,6.572-1.428S20,15.654,20,12s-.414-5.558-1.428-6.572S15.654,4,12,4s-5.558.414-6.572,1.428S4,8.346,4,12s.414,5.558,1.428,6.572S8.346,20,12,20Z",
    fill: "#ff3535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.a836866035f8263b512004b37076ac9b.svg";
export { ForwardRef as ReactComponent };